import React, { useEffect, useState } from 'react';
import { CookieConsentBanner } from '@porscheofficial/cookie-consent-banner-react';
import { EnvCmd } from 'env-cmd';

import logo from '../assets/EVS_LOGO_WHITE.png';
import PrivateRoute from '../routes/PrivateRoute';
import PublicRoute from '../routes/PublicRoute';
import { CallToActionProps, RouteProps } from '../utils/Types';
import ActionMenu from './ActionMenu';
import Home from './pages/Home';
import XtramotionConverter from './pages/XtramotionConverter';

import styles from './Main.module.scss';

const initConsent = ({ acceptedCategories }: any) => {
  // -------------------------------------------------------------------------
  // Error Tracking Service
  // Analytics
  // -------------------------------------------------------------------------
  if (acceptedCategories.includes('analytics')) {
    // console.log(acceptedCategories);
  }
};

let termsPath = '/terms.html';

if (process.env.NODE_ENV === 'production') {
  termsPath = `${process.env.REACT_APP_SITE}/xtramotion/terms.html`;
}

const Main = (props: CallToActionProps & RouteProps) => {
  const [acceptedCategories, setAcceptedCategories] = useState([]);

  useEffect(() => {
    // console.log(acceptedCategories);
  }, [acceptedCategories]);

  return (
    <div id="app" className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerLogoEVS}>
          <a
            href="https://evs.com?utm_source=XtraMotion+trial&utm_medium=referral&utm_campaign=XtraMotion+self+trial"
            target="_blank"
            rel="noreferrer"
          >
            <img src={logo} alt="EVS Logo" className={styles.logo} />
          </a>
        </div>
        <div className={styles.headerActionMenu}>
          <ActionMenu
            learnOnClick={() => props.learnOnClick()}
            contactOnClick={() => props.contactOnClick()}
            shareOnClick={() => props.shareOnClick()}
          />
        </div>
        <div className={styles.headerTitle}>
          <span className={styles.headerMainTitle}>XtraMotion</span>
          <span className={styles.headerSubTitle}>Cloud-based super slow-motion service</span>
        </div>
      </div>
      <div className={styles.content}>
        <PublicRoute isLoggedIn={props.isLoggedIn}>
          <Home />
        </PublicRoute>
        <PrivateRoute isLoggedIn={props.isLoggedIn}>
          <XtramotionConverter
            learnOnClick={() => props.learnOnClick()}
            contactOnClick={() => props.contactOnClick()}
            shareOnClick={() => props.shareOnClick()}
          />
        </PrivateRoute>
      </div>
      <div className={styles.footer}>
        <div className={styles.footerTextLeft}>© EVS Broadcast Equipment, all right reserved</div>
        <div className={styles.footerImage}>
          <img src={logo} alt="EVS Logo" className={styles.footerLogo} />
        </div>
        <div className={styles.footerTextRight}>
          <a href={termsPath} target="_blank" rel="noreferrer">
            XtraMotion Trial Terms of use
          </a>{' '}
          |{' '}
          <a href="https://evs.com/privacy-statement" target="_blank" rel="noreferrer">
            Privacy statement
          </a>{' '}
          |{' '}
          <a href="https://evs.com/terms-of-use" target="_blank" rel="noreferrer">
            Terms of use and cookie policy
          </a>
        </div>
        <div className={styles.bottomActionMenu}>
          <ActionMenu
            learnOnClick={() => props.learnOnClick()}
            contactOnClick={() => props.contactOnClick()}
            shareOnClick={() => props.shareOnClick()}
          />
        </div>
      </div>
      <CookieConsentBanner
        handlePreferencesUpdated={initConsent}
        handlePreferencesRestored={initConsent}
        btnLabelAcceptAndContinue="Accept all"
        headline="About cookies on this platform"
        btnLabelOnlyEssentialAndContinue="Refuse all"
        btnLabelSelectAllAndContinue="Select all and continue"
        btnLabelPersistSelectionAndContinue="Save selection and continue"
        contentSettingsDescription="
        Your privacy is our priority. You can configure your settings and choose how you want your personal data to be used according to the objectives below. You can configure the settings independently for each partner. You will find a description of each of the objectives on how our partners and we use your personal data.
For more information, please visit our Terms of Use & Cookies Policy."
        availableCategories={[
          {
            description:
              'Google Analytics is used in order to collect information about the number of visitors browsing the site, their sessions and how the pages they visit. Google Analytics processes the data and renders it in reports.\nAt EVS, we use these reports in order to understand the popularity of our content and to optimize the user experience on our site.',
            key: 'google_analytics',
            label: 'Google Analytics',
          },
        ]}
      >
        This application uses cookies to personalize and enhance your experience. By clicking <b>"Accept all”</b>, you
        agree to such use of cookies. If you want to disable all cookies or manage cookies, click on <b>“Refuse all”</b>{' '}
        or on <b>“Customize”</b>. For more information, please visit our{' '}
        <a href="https://evs.com/privacy-statement" target="_blank" rel="noreferrer">
          {' '}
          Terms of Use & Cookies Policy
        </a>
        . <br />
        <div
          className={styles.customizeButtonCookies}
          onClick={() => document.dispatchEvent(new Event('cookie_consent_details_show'))}
          onKeyPress={() => document.dispatchEvent(new Event('cookie_consent_details_show'))}
        >
          Customize
        </div>
      </CookieConsentBanner>
    </div>
  );
};

export default Main;
